import RunningHeaders from "./running-headers.js";
import StringSets from "./string-sets.js";
import TargetCounters from "./target-counters.js";
import TargetText from "./target-text.js";

export default [
	RunningHeaders,
	StringSets,
	TargetCounters,
	TargetText
];
